import React, { useState } from 'react';
import Modal from 'components/ModalPopup';
import { Button, Group, Select } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { moduleManagementService } from 'services/dacum/module.service';

interface FilterModuleCompetencyProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (_data: { value: string; label: string }) => void;
}

const FilterModuleCompetency: React.FC<FilterModuleCompetencyProps> = ({
  opened,
  onClose,
  onSubmit
}) => {
  const [selectedModule, setSelectedModule] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['moduleCompetency'],
    queryFn: () =>
      moduleManagementService.getModuleCompetency({
        sortOrder: 'asc',
        pageNumber: 1,
        pageSize: 1000
      })
  });

  const handleSubmit = () => {
    if (selectedModule) {
      onSubmit({
        value: selectedModule,
        label:
          data?.data.find((item) => item.trCompetencyModuleID === selectedModule)?.courseName || ''
      });
      onClose();
    }
  };

  return (
    <Modal title='Select Module' size='lg' opened={opened} close={onClose} withCloseButton>
      <Select
        label='Module Competency'
        placeholder='Select Module Competency'
        data={
          data?.data.map((item) => ({
            label: item.courseName,
            value: item.trCompetencyModuleID
          })) || []
        }
        value={selectedModule}
        onChange={(value) => setSelectedModule(value || '')}
        disabled={isLoading}
      />
      <Group justify='flex-end' mt={24}>
        <Button variant='outline' onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={!selectedModule}>
          Select
        </Button>
      </Group>
    </Modal>
  );
};

export default FilterModuleCompetency;
